import { DashboardCounterInput, DashboardDataGrid } from 'bd-web-components'
import { DataGridContainer } from '../styles'
import { FlowButtonControl } from '../../../../components/FlowButtonControl'
import { Dispatch, SetStateAction } from 'react'
import {
  courtesyDataConstructorProps,
  CourtesyRequestInitialProps,
} from '../../../../utils/courtesy-request-utils'
import { FormikProps } from 'formik'

interface TicketSelectorComponentProps {
  handleButtonClick: () => void
  rollBack: () => void
  setCounter: Dispatch<SetStateAction<number>>
  useFormikProps: FormikProps<CourtesyRequestInitialProps>
  name: keyof CourtesyRequestInitialProps
  limit: number
  count: number
  data: courtesyDataConstructorProps[]
}

export const AmountSelector = ({
  name,
  limit,
  count,
  setCounter,
  data,
  rollBack,
  handleButtonClick,
}: TicketSelectorComponentProps) => {
  const hasAmount = count !== 0
  return (
    <div>
      <DataGridContainer>
        <DashboardCounterInput
          name={name}
          title="Quantidade de Cortesias"
          counter={count}
          limit={limit}
          setCounter={setCounter}
        />
        {data[0] !== undefined && <DashboardDataGrid data={data} />}
      </DataGridContainer>
      <FlowButtonControl
        rollback={rollBack}
        flowControl={hasAmount}
        action={handleButtonClick}
      />
    </div>
  )
}
